import I18n from 'I18n';
import * as React from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const EnrollmentScheduleLabel = ({
  enrollmentSchedule
}) => {
  const {
    minute,
    hour,
    dayOfMonth,
    month,
    dayOfWeek
  } = enrollmentSchedule;
  const enrollTime = I18n.moment(`${hour.values[0]}:${minute.values[0]}`, 'H:mm').format('LT');
  if (dayOfWeek.expressionType === 'EVERY') {
    // Every day at certain time
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "flow-doctor-lib.flows.enrollmentSchedule.daily",
      options: {
        enrollTime
      }
    });
  }
  if (dayOfWeek.expressionType === 'VALUES') {
    // Every week on certain days of the week
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "flow-doctor-lib.flows.enrollmentSchedule.weekly",
      options: {
        daysOfWeek: I18n.formatList(dayOfWeek.values.map(day => I18n.moment().isoWeekday(day - 1).format('dddd'))),
        enrollTime
      }
    });
  }
  if (dayOfMonth.expressionType === 'VALUES' && month.expressionType === 'EVERY') {
    // Every month on certain days
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "flow-doctor-lib.flows.enrollmentSchedule.monthlyDays",
      options: {
        daysOfMonth: I18n.formatList(dayOfMonth.values.map(String)),
        enrollTime
      }
    });
  }
  if (dayOfWeek.expressionType === 'ON_NTH_WEEKDAY') {
    // Every month on first monday
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "flow-doctor-lib.flows.enrollmentSchedule.firstMonday",
      options: {
        enrollTime
      }
    });
  }
  if (dayOfMonth.expressionType === 'ON_LAST_DAY') {
    // Every month on last day of month + time
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "flow-doctor-lib.flows.enrollmentSchedule.lastDay",
      options: {
        enrollTime
      }
    });
  }
  if ([dayOfMonth.expressionType, dayOfWeek.expressionType, month.expressionType].includes('DELEGATE_TO_PROPERTY_VALUE')) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "flow-doctor-lib.flows.enrollmentSchedule.basedOnProperty",
      options: {
        propertyName: enrollmentSchedule.dateProperty.propertyName
      }
    });
  }

  // Else, run annually on dates + time
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: "flow-doctor-lib.flows.enrollmentSchedule.annual",
    options: {
      daysOfMonth: I18n.formatList(dayOfMonth.values.map(String)),
      monthOfYear: I18n.moment(month.values[0], 'M').format('MMMM'),
      enrollTime
    }
  });
};
export default EnrollmentScheduleLabel;